export const parentLinks = {
  YOURPROFILE: 'Your profile',
  FINDACAR: 'Find a car',
  PARTEXCHANGE: 'Part exchange',
  VALUEMYCAR: 'Value my car',
  CARCARE: 'Servicing',
  CARFINANCE: 'Car finance',
  HOWCINCHWORKS: 'How cinch works',
  NEWCAROFFERS: 'New car offers',
  USEDCARS: 'Used cars',
  NEWCARS: 'New cars',
} as const
